// extracted by mini-css-extract-plugin
module.exports = {"popupContainer":"WmsExternalIdsSimpleText_popupContainer__1ga5q","icon":"WmsExternalIdsSimpleText_icon__3e01X","popupElement":"WmsExternalIdsSimpleText_popupElement__1Kbkh"};